import React, { useRef, useEffect } from 'react';
import './Gloves.scss';
import videomov from '../../../../assets/contemporary/gloves/contemporary_gloves.mov';
import video from '../../../../assets/contemporary/gloves/contemporary_gloves.webm';
import poster from '../../../../assets/contemporary/gloves/contemporary_gloves_poster.png';

function ContemporaryGloves() {
  const videoRef = useRef();
  const glovesRef = useRef();
  useEffect(() => {
    videoRef.current.load();
    const videoCurrent = videoRef.current;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry['isIntersecting'] === true) {
            videoCurrent.play();
          }
        });
      },
      { threshold: [0, 0.1] }
    );
    observer.observe(videoCurrent);
  }, []);
  return (
    <section className="gloves gloves-contemporary" ref={glovesRef}>
      <div className="gloves__animation gloves__animation-contemporary">
        <video
          muted
          playsInline
          preload="auto"
          ref={videoRef}
          className="gloves__animation__video"
          poster={poster}
        >
          <source src={videomov} type="video/quicktime" />
          <source src={video} type="video/webm" />
        </video>
      </div>
      <div className="gloves__text gloves__text-contemporary">
        <p className="gloves__text__title gloves__text__title-contemporary">
          Digitally Scanned Custom Fit
        </p>
        <p className="gloves__text__copy">
          Glove fit is achieved by digitally scanning astronauts' hands and matching them with a
          library of about 200 hand sizes.
        </p>
      </div>
    </section>
  );
}

export default ContemporaryGloves;
